module.exports = __webpack_public_path__ + "ski-selector.91cf99dc384a629a6a70.png";


//////////////////
// WEBPACK FOOTER
// /vercel/path0/src/assets/img/ski-selector.png
// module id = ../../../../../src/assets/img/ski-selector.png
// module chunks = main